import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTop from '../../components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceZone from './components/ServiceZone';
import TestimonialsSection from './components/TestimonialsSection';
import QuoteFormSection from './components/QuoteFormSection';
import { useSEO } from '../../utils/seo';

const HomePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hormipremium.com';

  useSEO({
    title: 'Estepona Hormigón Decorativo HORMI PREMIUM | Hormigón Impreso, Pulido y Piscinas',
    description: 'HORMI PREMIUM - Especialistas en hormigón decorativo en Estepona y Costa del Sol. Ofrecemos hormigón impreso, desactivado, pulido y piscinas de arena Arelite. Más de 15 años de experiencia. Presupuesto gratis.',
    keywords: 'hormigón decorativo Estepona, hormigón impreso, hormigón pulido, piscinas Arelite, pavimentos decorativos Costa del Sol',
    canonical: `${siteUrl}/`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'HORMI PREMIUM',
      description: 'Especialistas en hormigón decorativo, impreso, pulido y piscinas de arena Arelite en Estepona y Costa del Sol',
      image: 'https://static.readdy.ai/image/5fa39b647fe9b9756d6d13910558d3e0/22dc4b37e72a444c4964897dd25d2553.png',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Estepona',
        addressRegion: 'Andalucía',
        addressCountry: 'ES',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '36.4277',
        longitude: '-5.1483',
      },
      telephone: '+34640877479',
      priceRange: '€€',
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '08:00',
          closes: '18:00',
        },
      ],
      areaServed: {
        '@type': 'GeoCircle',
        geoMidpoint: {
          '@type': 'GeoCoordinates',
          latitude: '36.4277',
          longitude: '-5.1483',
        },
        geoRadius: '50000',
      },
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <AboutSection />
        <WhyChooseUs />
        <ServiceZone />
        <TestimonialsSection />
        <QuoteFormSection />
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTop />
    </div>
  );
};

export default HomePage;
